export default __webpack_public_path__ + "static/media/968.b346d38b.png";